"use client";

import { LazyMotion, m } from "framer-motion";
import type { ReactNode } from "react";

// As features de animação (domAnimation) são carregadas em chunk separado e async,
// tirando o grosso do framer-motion do caminho crítico. O `m` é o componente leve
// (renderiza no SSR); as animações entram assim que as features carregam.
const loadFeatures = () => import("./motion-features").then((mod) => mod.default);

// Mesma API <MotionDiv> usada na app, agora sobre o `m` (leve) em vez de `motion` (pesado).
export const MotionDiv = m.div;

// Provider que carrega as features. Deve envolver qualquer árvore que use MotionDiv/m.
export function LazyMotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
}
